import { BundleCatalog } from '@landr/pricing';
import { useMemo } from 'react';

export const FREE_DOWNLOAD_CODE = 'free_download'; // This is a fake product

export const useBasicDownload = ({
    studioCatalog,
}: {
    studioCatalog: BundleCatalog | undefined;
}) => {
    const code = FREE_DOWNLOAD_CODE;
    const currency = studioCatalog?.currency;
    const price = useMemo(() => {
        if (!currency) {
            return null;
        }

        return currency?.currencySymbol === '$'
            ? `${currency.currencySymbol}${0}`
            : `${0}${currency.currencySymbol}`;
    }, [currency]);

    const title = 'Basic download';

    return {
        code,
        currency,
        price,
        title,
    };
};
